import { IComponentOptions } from "angular";
import { MachineConfigurationTypeInfoComponentController } from "./controller";

export const vsComponentName = "machineConfigurationTypeInfoComponent";

export const machineConfigurationTypeInfoComponentOptions: IComponentOptions = {
  controller: MachineConfigurationTypeInfoComponentController,
  controllerAs: "machineConfigurationTypeInfoComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurationType: "<",
  },
};
